import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
} from '@angular/core';

import { TranslationKeyMap } from '../coaching-observation.i18n';

@Component({
    selector: '[cmpsObservationNavigator]',
    templateUrl: './navigator.observation.component.html',
})
export class ObservationNavigatorComponent implements OnDestroy {
    /** @private */ _i18n = TranslationKeyMap;

    @Input() previousDisabled: boolean;
    @Output() previous: EventEmitter<void>;
    @Input() nextDisabled: boolean;
    @Output() next: EventEmitter<void>;

    constructor() {
        this.previous = new EventEmitter();
        this.next = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.previous.complete();
        this.next.complete();
    }
}
